"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVideoLoading = void 0;

var _react = require("react");

const useVideoLoading = videoTag => {
  const [isLoading, setLoading] = (0, _react.useState)(false);

  function onLoadStart() {
    console.log('load start');
    setLoading(true);
  }

  function onLoadEnd() {
    console.log('load end');
    setLoading(false);
  }

  (0, _react.useEffect)(() => {
    videoTag.addEventListener('loadstart', onLoadStart);
    videoTag.addEventListener('canplay', onLoadEnd);
    return () => {
      videoTag.removeEventListener('loadstart', onLoadStart);
      videoTag.removeEventListener('canplay', onLoadEnd);
    };
  }, [videoTag.src]);
  return isLoading;
};

exports.useVideoLoading = useVideoLoading;